import axiosInstance from './axiosConfig';

/**
 * Servicio API para integración con Flow
 */

/**
 * Crea una orden de pago en Flow
 * @param {Object} paymentData - Datos del pago
 * @param {string} paymentData.bookingUid - UID de la reserva en Cal.com
 * @param {string} paymentData.email - Email del cliente
 * @param {number} paymentData.amount - Monto a pagar en CLP
 * @param {string} paymentData.subject - Asunto/descripción del pago
 * @returns {Promise<Object>} Respuesta con checkoutUrl
 */
export const createPayment = async (paymentData) => {
  try {
    const response = await axiosInstance.post('/flow/create-payment', {
      bookingUid: paymentData.bookingUid,
      email: paymentData.email,
      amount: paymentData.amount,
      subject: paymentData.subject,
    });

    return response.data;
  } catch (error) {
    console.error('Error al crear pago:', error);
    throw error;
  }
};

/**
 * Verifica el estado de un pago en Flow
 * @param {string} token - Token del pago recibido de Flow
 * @returns {Promise<Object>} Estado del pago con { status, bookingUid, amount, flowOrder }
 */
export const checkPaymentStatus = async (token) => {
  try {
    const response = await axiosInstance.get('/flow/get-status', {
      params: { token },
    });

    return response.data;
  } catch (error) {
    console.error('Error al verificar estado del pago:', error);
    throw error;
  }
};

const flowAPI = {
  createPayment,
  checkPaymentStatus,
};

export default flowAPI;
